<template>
  <div class="tos-page">
    <main class="container">
      <h1>ĐIỀU KHOẢN SỬ DỤNG ỨNG DỤNG HKOIL</h1>
      <p class="intro">Cập nhật lần cuối: 14/11/2025<br>Chào mừng bạn đến với ứng dụng HKOIL.<br>Vui lòng đọc kỹ Điều khoản Sử dụng này trước khi tiếp tục sử dụng ứng dụng.</p>
      <section>
        <h2>1. Chấp nhận điều khoản</h2>
        <p>Bằng việc tải, cài đặt hoặc sử dụng ứng dụng HKOIL, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý tuân thủ toàn bộ Điều khoản Sử dụng này.<br>Nếu bạn không đồng ý với bất kỳ nội dung nào, vui lòng ngừng sử dụng ứng dụng.</p>
      </section>
      <section>
        <h2>2. Mục đích ứng dụng</h2>
        <p>Ứng dụng HKOIL được cung cấp nhằm hỗ trợ khách hàng của HKOIL trong việc:</p>
        <ul>
          <li>Theo dõi lịch sử giao dịch và mua hàng.</li>
          <li>Tích điểm và đổi quà theo chương trình khách hàng thân thiết.</li>
          <li>Nhận thông báo, tin tức và ưu đãi từ HKOIL.</li>
          <li>Quản lý thông tin cá nhân và phương tiện.</li>
          <li>Các chức năng khác được HKOIL cập nhật theo từng thời điểm.</li>
        </ul>
        <p>Ứng dụng chỉ phục vụ cho mục đích hợp pháp và cá nhân.</p>
      </section>
      <section>
        <h2>3. Tài khoản người dùng</h2>
        <ul>
          <li>Người dùng cần đăng nhập tài khoản bằng thông tin chính xác và đầy đủ.</li>
          <li>Bạn có trách nhiệm bảo mật thông tin đăng nhập.</li>
          <li>Mọi hoạt động phát sinh từ tài khoản của bạn đều do bạn chịu trách nhiệm.</li>
          <li>HKOIL có quyền khóa hoặc thu hồi tài khoản nếu phát hiện hành vi vi phạm điều khoản hoặc gian lận điểm thưởng.</li>
        </ul>
      </section>
      <section>
        <h2>4. Quyền và trách nhiệm của người dùng</h2>
        <p>Người dùng cam kết:</p>
        <ul>
          <li>Không sử dụng ứng dụng cho mục đích vi phạm pháp luật.</li>
          <li>Không can thiệp, phá hoại, sao chép trái phép mã nguồn hoặc dữ liệu hệ thống.</li>
          <li>Không giả mạo thông tin để trục lợi điểm thưởng hoặc ưu đãi.</li>
        </ul>
        <p>Người dùng có quyền:</p>
        <ul>
          <li>Truy cập và sử dụng các chức năng hợp lệ của ứng dụng.</li>
          <li>Liên hệ hỗ trợ khi gặp sự cố kỹ thuật hoặc có vấn đề liên quan đến tài khoản.</li>
        </ul>
      </section>
      <section>
        <h2>5. Quyền và trách nhiệm của HKOIL</h2>
        <p>HKOIL có quyền:</p>
        <ul>
          <li>Cập nhật, thay đổi hoặc chấm dứt chức năng ứng dụng mà không cần thông báo trước.</li>
          <li>Tạm ngưng hoặc khóa tài khoản người dùng vi phạm.</li>
          <li>Thu thập và xử lý dữ liệu theo Chính sách bảo mật.</li>
        </ul>
        <p>HKOIL cam kết:</p>
        <ul>
          <li>Bảo mật thông tin người dùng theo quy định pháp luật.</li>
          <li>Duy trì hoạt động ổn định của ứng dụng, trừ trường hợp bất khả kháng hoặc bảo trì.</li>
        </ul>
      </section>
      <section>
        <h2>6. Tích điểm và đổi quà</h2>
        <ul>
          <li>Chính sách tích điểm và đổi quà có thể thay đổi theo từng thời điểm.</li>
          <li>Mọi điểm tích lũy, quà tặng, khuyến mãi đều thuộc quyền quản lý của HKOIL.</li>
          <li>HKOIL có quyền điều chỉnh, thu hồi hoặc từ chối cấp điểm đối với các giao dịch không hợp lệ.</li>
        </ul>
      </section>
      <section>
        <h2>7. Thu thập và bảo mật dữ liệu</h2>
        <p>Việc thu thập và xử lý dữ liệu cá nhân được thực hiện theo Chính sách bảo mật đính kèm.<br>Người dùng được xem và yêu cầu cập nhật thông tin cá nhân theo quy định.</p>
      </section>
      <section>
        <h2>8. Sở hữu trí tuệ</h2>
        <ul>
          <li>Tất cả nội dung, hình ảnh, logo, giao diện trong ứng dụng thuộc quyền sở hữu của HKOIL.</li>
          <li>Nghiêm cấm sao chép, sửa đổi, sử dụng trái phép dưới bất kỳ hình thức nào.</li>
        </ul>
      </section>
      <section>
        <h2>9. Giới hạn trách nhiệm</h2>
        <p>HKOIL không chịu trách nhiệm đối với:</p>
        <ul>
          <li>Các thiệt hại phát sinh từ việc người dùng cung cấp thông tin sai.</li>
          <li>Sự cố kỹ thuật, mất dữ liệu do đường truyền hoặc thiết bị người dùng.</li>
          <li>Hành vi gian lận hoặc truy cập trái phép từ bên thứ ba.</li>
        </ul>
      </section>
      <section>
        <h2>10. Chấm dứt sử dụng</h2>
        <p>HKOIL có thể chấm dứt quyền truy cập của bạn nếu bạn vi phạm điều khoản hoặc sử dụng ứng dụng sai mục đích.<br>Người dùng có thể tự chấm dứt sử dụng bằng cách ngừng dùng và xóa ứng dụng khỏi thiết bị.</p>
      </section>
      <section>
        <h2>11. Thay đổi điều khoản</h2>
        <p>HKOIL có quyền thay đổi Điều khoản Sử dụng theo từng thời điểm.<br>Phiên bản cập nhật sẽ được công bố trong ứng dụng hoặc trên website.</p>
      </section>
      <section class="contact">
        <h2>12. Liên hệ hỗ trợ</h2>
        <p><a href="mailto:info@hkoil.org">📧 Email: info@hkoil.org</a></p>
      </section>
    </main>
  </div>
</template>
<script>
// Đặt tên component multi-word để thỏa eslint rule
export default {
  name: 'TermsOfServicePage'
};
</script>
<style scoped>
.tos-page { padding: 28px 12px; display:flex; justify-content:center; }
.container { width:100%; max-width:900px; background:#fff; border-radius:10px; padding:24px; box-shadow:0 6px 24px rgba(0,0,0,0.06); color:#222; line-height:1.6; }
h1{ font-size:20px; margin-bottom:8px; color:#2d4a8a }
h2{ font-size:16px; margin-top:16px; color:#1f4a73 }
.intro{ margin-bottom:12px; color:#444 }
.contact{ margin-top:14px; font-weight:600 }
.contact a {color: #0b6b3f;text-decoration: none;}
@media (max-width:600px){ .container{ padding:16px } h1{font-size:18px} h2{font-size:15px} }
</style>